export default class CABA1010RequestModel {}
